export default __webpack_public_path__ + "static/hero-2492e86b3b9932a4c943e332a4890def.png";